<template>
  <!-- Shared frame for every slide-specific preview.
       Slot `presenter` is required (the big-screen mockup);
       slot `audience` is optional (the phone mockup, hidden for static slides). -->
  <div
    class="frame"
    :data-has-audience="hasAudience"
    :style="{ '--accent': accent || '#6A1EBB' }"
  >
    <figure class="frame-panel frame-panel--presenter">
      <figcaption class="frame-cap">
        Presenter screen
      </figcaption>
      <div class="frame-stage">
        <slot name="presenter" />
      </div>
    </figure>
    <figure v-if="hasAudience" class="frame-panel frame-panel--audience">
      <figcaption class="frame-cap">
        Audience phone
      </figcaption>
      <div class="frame-phone">
        <span class="frame-phone-notch"></span>
        <div class="frame-phone-screen">
          <slot name="audience" />
        </div>
      </div>
    </figure>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'PreviewFrame',
  props: {
    accent: { type: String, default: '#6A1EBB' },
  },
  computed: {
    hasAudience(): boolean {
      return !!this.$slots.audience
    },
  },
})
</script>

<style scoped lang="scss">
.frame {
  --ease-out: cubic-bezier(0.23, 1, 0.32, 1);
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 16px;
  padding: 18px;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--accent) 22%, transparent);
  background: color-mix(in srgb, var(--accent) 6%, white);
}
.frame[data-has-audience='false'] { grid-template-columns: 1fr; }

.frame-cap {
  font-size: 10px; font-weight: 700;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: rgba(15, 15, 20, 0.45);
  margin: 0 0 8px;
}

.frame-panel { margin: 0; min-width: 0; }
.frame-stage {
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(15, 15, 20, 0.04);
  padding: 16px 18px;
  min-height: 168px;
  display: flex; flex-direction: column; gap: 10px;
}

.frame-phone {
  position: relative;
  background: #1A1A2E;
  border-radius: 22px;
  padding: 10px 6px 12px;
  margin: 0 auto;
  width: 154px;
  box-shadow:
    0 1px 0 rgba(15, 15, 20, 0.1),
    0 12px 24px -10px rgba(15, 15, 20, 0.25);
}
.frame-phone-notch {
  display: block;
  width: 50px; height: 6px; border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  margin: 0 auto 8px;
}
.frame-phone-screen {
  background: white;
  border-radius: 14px;
  padding: 12px 10px;
  display: grid; gap: 7px;
  min-height: 200px;
}

@container market (max-width: 640px) {
  .frame { grid-template-columns: 1fr; }
  .frame-phone { width: 100%; max-width: 240px; }
}
</style>
